import styled from 'styled-components';

const BlueText = styled.div`
  color: blue;
  font-size: 12px;
  color: var(--accent-color-blue);
  font-weight: 500;
`;
export default BlueText;
